import EmailLink from "../components/EmailLink";
import styles from "./Impressum.module.css";

export default function Impressum() {
  return (
    <section className={styles.page}>
      <h2 className={styles.title}>Impressum</h2>

      <div className={styles.grid}>
        <div className={styles.label}>Angaben gemäß § 5 TMG</div>
        <div className={styles.value}>
          <strong>enercity AG</strong>
          <br />
          <strong>DUOday Hannover</strong>
          <br />
          Glockseeplatz 1
          <br />
          30169 Hannover
          <br />
          <br />
          Telefon: <a href="tel:+495114303016" className={styles.link}>+49 511 430 3016</a>
          <br />
          Telefax: <a href="tel:+491622595194" className={styles.link}>+49 162 2595194</a>
          <br />
          E-Mail: <EmailLink user="duoday-hannover" domain="enercity.de" className={styles.link} />
        </div>

        <div className={styles.label}>Vertreten durch den Vorstand</div>
        <div className={styles.value}>
          Aurélie Alemany (Vorstandsvorsitzende)
          <br />
          Prof. Dr. Marc Hansmann
          <br />
          Eefje Pompen
        </div>

        <div className={styles.label}>USt-IdNr.</div>
        <div className={styles.value}>DE 811116141</div>

        <div className={styles.label}>Registergericht</div>
        <div className={styles.value}>
          Amtsgericht Hannover
          <br />
          Registernummer: HRB6766
        </div>

        <div className={styles.label}>Verantwortlich für den Inhalt</div>
        <div className={styles.value}>
          Herr Kevin Kielhorn (Anschrift s. o.)
        </div>

        <div className={styles.label}>Streitbeilegung</div>
        <div className={styles.value}>
          Die enercity AG wird für die hier angebotenen digitalen Dienste nicht an
          einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilnehmen und ist auch nicht dazu verpflichtet.
        </div>
      </div>
    </section>
  );
}